// 現在のパスの一番最後の部分（スラッグ）を取得
let pathParts = window.location.pathname.split("/").filter(Boolean);
let lastPath = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";

// すべての.listItemを取得
document.querySelectorAll(".listItem").forEach(function (item) {
  const id = item.id;
  if (!id) return;

  // ルートパス（"/"）の場合はid="home"と一致させる
  if ((lastPath === "" && id === "home") || lastPath === id) {
    item.classList.add("is-active");
  }
});
